











































































































// require('./lib/ui/root.js');

import ripple from "../../components/ripple.vue"
import tooltip from "../../components/tooltip.vue"
import gbutton from "../../components/button.vue"
import graph from "../../components/graph.vue"
import inlineTextEdit from "../../components/inlineTextEdit.vue"

import dropdown, { DropdownInterface, DropdownItem } from "../../components/dropdownMenu.vue"
import dateSelector from "../../components/dateSelector.vue"
import DropdownMenu from "../../components/dropdownMenu.vue";
import moment,{ weekdays, Moment } from "moment";

import {frontendClient} from "../../lib/client"
import {HTTPPostAPI} from "../../lib/httpapi"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setInterval } from "timers";

@Component({
    components : {
        ripple,
        gbutton,
        graph,
        tooltip,
        dateSelector,
        DropdownMenu,
        dropdown,
        inlineTextEdit
    },
})
export default class Updates extends Vue{
    fromSelector:boolean = false;
    toSelector:boolean = false;
    
    range:{
        from:number,
        to:number
    } = {
        from: new Date().setHours(0,0,0,0),
        to: new Date().setHours(23,59,59,59)
    };

    searchVal:string = null;

    selectedClient:string = null;
    selectedClientGraph:any = null;

    openMore:boolean = false;
    
    clients:string[] = [];
    viewingClientName: string = null;

    parameters:DropdownInterface = {
        type: "options",
        items: [
            {
                name:"Jobs",
                icon: 'assignment',
                function: () => {},
                focus: true,
            },
            {
                name:"Payments",
                icon: 'attach_money',
                function: () => {},
                focus: true,
            },
            {
                name:"Letters",
                icon: 'mail',
                function: () => {},
                focus: true,
            },
        ]
    }

    getDates(){
        this.range.from = moment(this.range.to).subtract(7, 'days').toDate().setHours(0,0,0,0);
    }

    redirect(route,parameters?){
        if(parameters){
            this.$router.replace({ name: route, params: parameters});
        }else{
            this.$router.push({ name: route, params: parameters});
        }
    };
    

    // date selectors
    openFromSelector(x){
        this.fromSelector = true;
    }
    openToSelector(x){
        this.toSelector = true;
    }
    closeFrom(x){
        this.fromSelector = false;
    }
    closeTo(x){
        this.toSelector = false;
    }
    closeRanges(){
        this.fromSelector = false;
        this.toSelector = false;
    }


    mounted(){
       this.$emit('scope','clients'); // FIXME: should scope really be `clients`?
       this.loadUserList();
       this.getDates();
       this.updateGraphs();
    }

    async loadUserList() {
        this.clients = (await frontendClient.postEx("graph/clients/list",{})).clients;
        this.changeFocus();
    }

    updateSearch(newVal){
        this.searchVal = newVal;
        this.searchVal = this.searchVal?this.searchVal.toLowerCase():'';
    }

    selectClient(client?){
        if(!client) client = null;
        this.selectedClient = client;
        this.updateGraphs();
    }

    async updateGraphs(){
        this.selectedClientGraph = await frontendClient.post("graph/clients/stats",{
            from: this.range.from,
            to: this.range.to,
            clientName: this.selectedClient?this.selectedClient:"all"
        })

        this.selectedClientGraph.graphValues.sort(function(a,b){
            return a.time - b.time;
        });
    }

    

    @Watch("$route.params.name")
    changeFocus(){
        this.viewingClientName = null;
        if(this.$route.params.name){
            for(let i=0;i<this.clients.length;i++){
                if(this.clients[i] == this.$route.params.name){
                    this.selectClient(this.clients[i]);
                    this.viewingClientName = this.clients[i];
                    break;
                }
            }
        }
    }
}
